// extracted by mini-css-extract-plugin
export default {"isDragActive":"Upload_isDragActive__bpcUA"};